import React, { type ReactNode } from "react";

import {
  CommonBlocksProvider,
  useCommonBlocksContext,
} from "./CommonBlocksContext";
import { DashboardProvider, useDashboardContext } from "./DashboardContext";
import {
  PopulationBuilderProvider,
  usePopulationBuilderContext,
} from "./PopulationBuilderContext";

export {
  CommonBlocksProvider,
  useCommonBlocksContext,
  DashboardProvider,
  useDashboardContext,
  PopulationBuilderProvider,
  usePopulationBuilderContext,
};

interface InsightsContextProps {
  children: ReactNode;
}

export const InsightsContextProvider = ({ children }: InsightsContextProps) => (
  <DashboardProvider>
    <PopulationBuilderProvider>
      <CommonBlocksProvider>{children}</CommonBlocksProvider>
    </PopulationBuilderProvider>
  </DashboardProvider>
);
